import { getCountryList } from "@scrile/tools/dist/lib/countryList";

export const countryList = getCountryList(["US", "CA"]);
